import { PartnerSkills } from "Infrastructure/Api/Api";
import { z } from "zod";

export const getPartnerFilterFormSchema = () => {
	return z.object({
		query: z.string().nullish(),
		skills: z.array(z.nativeEnum(PartnerSkills)).optional(),
	});
};

export type PartnerFilterFormModel = z.infer<
	ReturnType<typeof getPartnerFilterFormSchema>
>;
